import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BookOpen } from "lucide-react";
import storyCover from "@/assets/story-cover.png";
interface StoryCardProps {
  story: {
    id: string;
    title: string;
    character_name: string;
    qualities: string[];
    tempo: string;
    created_at: string;
    image_url: string | null;
    thumbnail_url: string | null;
  };
  onClick: () => void;
}
const StoryCard = ({
  story,
  onClick
}: StoryCardProps) => {
  const formattedDate = new Date(story.created_at).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  const coverImage = story.thumbnail_url || story.image_url || storyCover;
  
  return <Card className="cursor-pointer hover:shadow-md hover:border-primary transition-all duration-200 bg-card overflow-hidden" onClick={onClick}>
      <div className="mb-0">
        <img src={coverImage} alt={`Illustration for ${story.title}`} className="w-full h-48 object-cover" loading="lazy" />
      </div>
      <div className="p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <BookOpen className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-foreground mb-1 line-clamp-2 font-sans">
              {story.title}
            </h3>
            {story.character_name !== "the main character" && (
              <p className="text-sm text-muted-foreground">
                Starring: {story.character_name}
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-3">
          {story.qualities.slice(0, 2).map(quality => (
            <Badge key={quality} variant="secondary" className="text-xs px-2 py-0.5">
              {quality}
            </Badge>
          ))}
        </div>
        <p className="text-xs text-muted-foreground">{formattedDate}</p>
      </div>
    </Card>;
};
export default StoryCard;